





















































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {DialogRemove} from '@/helpers/dialog/DialogRemove'
import {TipoVeiculo} from '@/model/resource/TipoVeiculo'
import {TipoVeiculoCollection} from '@/model/collection/TipoVeiculoCollection'
import {ListTipoVeiculoSchema} from '@/schema/resource/TipoVeiculo/ListTipoVeiculoSchema'
import {CsvTipoVeiculoSchema} from '@/schema/resource/TipoVeiculo/CsvTipoVeiculoSchema'

@Component
export default class ListTipoVeiculoView extends Mixins(MixinQueryRouter) {
  schema = new ListTipoVeiculoSchema()
  collection = new TipoVeiculoCollection()

  async created() {
    this.collection.perPage = 20
    await this.query()
  }

  goToPersistView(item: TipoVeiculo) {
    Helper.pushByName('editTipoVeiculo', item.$id)
  }

  async removeItem(item: TipoVeiculo) {
    await new DialogRemove(item).confirm(() =>
      item.deleteTipoVeiculoById(item.idTipoVeiculo)
    )
    await this.collection.listTipoVeiculo()
  }

  async downloadXlsx() {
    const {ascending, orderBy, page, limit, ...params} = this.collection.params

    const collection = new TipoVeiculoCollection()
      .clearFilters()
      .addFilter(params)

    await collection.listCsvTipoVeiculo()

    this.$xlsx.downloadFromSchema(
      collection.all(),
      new CsvTipoVeiculoSchema(),
      'tipo_veiculo'
    )
  }
}
